import { action, Action } from 'easy-peasy';
import { MeidouInfoType } from '@meitu/xdesign-widgets/dist/types/meidouInfo';
import { UserInfoType } from '@meitu/xdesign-widgets/dist/types/userInfo';
import { CutoutInfo } from '@meitu/xdesign-widgets/dist/types/cutout';

export type IUserInfoType = UserInfoType & { available_amount?: number };
export interface IUserType {
  /**
   * 用户信息
   */
  userInfo?: IUserInfoType;
  setUserInfo: Action<IUserType, IUserInfoType | undefined>;

  /**
   * 美豆信息
   */
  meidouInfo: MeidouInfoType | null;
  setMeidouInfo: Action<IUserType, MeidouInfoType | null>;

  /**
   * 抠图账号信息
   */
  cutoutInfo: CutoutInfo | null;
  setCutoutInfo: Action<IUserType, CutoutInfo | null>;

  /**
   * 是否已经请求过了
   */
  isRequested: boolean;
  setIsRequested: Action<IUserType, boolean>;
}

export const userModel: IUserType = {
  userInfo: undefined,
  setUserInfo: action((state, value) => {
    state.userInfo = value;
  }),
  meidouInfo: null,
  setMeidouInfo: action((state, value) => {
    state.meidouInfo = value;
  }),
  cutoutInfo: null,
  setCutoutInfo: action((state, value) => {
    state.cutoutInfo = value;
  }),
  isRequested: false,
  setIsRequested: action((state, value) => {
    state.isRequested = value;
  }),
};
